import { render, staticRenderFns } from "./VmBox.vue?vue&type=template&id=73691e24&scoped=true&"
import script from "./VmBox.vue?vue&type=script&lang=js&"
export * from "./VmBox.vue?vue&type=script&lang=js&"
import style0 from "./VmBox.vue?vue&type=style&index=0&id=73691e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73691e24",
  null
  
)

export default component.exports